<template>
  <div class="breadcrumb-menu" data-cy="breadcrumb-menu">
    <ul class="crumbs">
      <li
        v-for="(crumb, index) in crumbs"
        :key="crumb.name"
        class="crumbs-item"
        :class="[{ clickable: isCrumbActive(index) }]">
        <router-link
          :to="crumb.routerPath"
          :disabled="!isCrumbActive(index)"
          :data-cy="crumb.id"
          @click.capture="handleClick($event, index)">
          <span>
            {{ crumb.name }}
          </span>
        </router-link>
        <i class="right-arrow"></i>
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import { type BreadcrumbItem } from '@/models/breadcrumb-item';

import { defineComponent } from 'vue';

export default defineComponent({
  name: 'breadcrumb-menu',
  props: {
    crumbs: {
      type: Array<BreadcrumbItem>,
      default: [],
    },
  },
  methods: {
    isCrumbActive(crumbIndex: number) {
      const currentPathNormalized =
        this.$router.currentRoute.value.path.charAt(-1) === '/'
          ? this.$router.currentRoute.value.path.slice(0, -1)
          : this.$router.currentRoute.value.path;
      const selectedCrumbItemIndex = this.crumbs.findIndex(
        (crumb) => crumb.routerPath === decodeURIComponent(currentPathNormalized),
      );

      return crumbIndex <= selectedCrumbItemIndex;
    },
    handleClick(event: Event, index: number) {
      if (!this.isCrumbActive(index)) {
        event.stopPropagation();
        event.preventDefault();
      }
    },
  },
});
</script>

<style scoped="true" lang="scss">
.breadcrumb-menu {
  font-family: 'On Mono';
  font-size: 14px;

  .crumbs {
    justify-content: center;
    display: flex;
    list-style: none;
    padding: 0;
    margin: 0;

    .crumbs-item {
      display: flex;
      justify-content: center;
      align-items: center;

      @include breakpoint(medium) {
        font-size: 12px;
      }

      a {
        color: var(--primary-text-remark-unselected-color);
        cursor: not-allowed;
      }

      &.clickable a,
      a.router-link-active {
        color: var(--black-color);
        cursor: pointer;
      }

      a.router-link-active {
        text-underline-offset: 15px;
        text-decoration: underline;
      }

      &:last-child {
        background: none;
        padding: 0;
        margin: 0;

        i.right-arrow {
          display: none;
        }
      }

      i.right-arrow {
        @include icon-image('@/assets/img/ico-arrow-right-breadcrumb.svg', var(--primary-text-color));
        display: block;
        width: 20px;
        height: 20px;
        padding: 0 0px 0 20px;
        margin: 0 25px 0 20px;
      }
    }
  }
}
</style>
